import React from 'react';
import Box from '../Box/Box';

interface CollapseProps {
    open: boolean;
}

const Collapse: React.FC<CollapseProps> = ({ open, children, ...props }) => (
    <>{open ? <Box {...props}>{children}</Box> : null}</>
);

export default Collapse;
